import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AlertNotice, ModalInfo, AlertMessage, Textarea } from 'shared/components';
import * as requestUpdateActions from 'features/request-update/duck';
import * as notificationsActions from 'features/notifications/duck';
import { REQUEST_UPDATE_TYPE, REQUEST_UPDATE_STATUS } from 'shared/constants';
import { isEmpty, isEqual } from 'lodash';
import CloseCircle from 'assets/svgs/closeCircle.svg';
import './CloseTestCenter.scss';
import PendingIcon from 'assets/svgs/pendingIcon.svg';

const MAX_LENGTH = 360;

class CloseTestCenter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alertMessage: '',
      showAlertMessage: false,
      reason: '',
      showReview: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.cancelRequest = this.cancelRequest.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { currentRequest } = this.props;

    if (!isEqual(prevProps.currentRequest, this.props.currentRequest)) {
      this.setState({
        reason:
          currentRequest &&
          currentRequest.data &&
          currentRequest.data.eventClose &&
          currentRequest.type === REQUEST_UPDATE_TYPE.closeTcEvent
            ? currentRequest.data.eventClose.reason
            : '',
      });
    }
  }

  onChange(e) {
    const { value } = e.target;

    this.setState({
      reason: value,
    });
  }

  async cancelRequest() {
    const { tcId, testingEventId } = this.props;
    await this.props.actions.updateRequest({
      testCenterId: tcId,
      testingEventId: testingEventId,
      status: REQUEST_UPDATE_STATUS.cancelled,
    });
    this.setState({
      showAlertMessage: true,
      reason: '',
      alertMessage: 'requestUpdate.cancelRequest.successCloseTcEvent',
    });
    this.props.actions.getRequestUpdate(tcId, testingEventId);
    this.props.toggleModal();
  }

  async onSubmit() {
    const { reason, showReview } = this.state;
    const { actions, tcId, testingEventId, currentRequest, userId } = this.props;

    if (showReview) {
      const data = {
        testCenterId: tcId,
        testingEventId: testingEventId,
        type: REQUEST_UPDATE_TYPE.closeTcEvent,
        data: {
          eventClose: {
            reason: reason,
          },
        },
      };
      if (currentRequest.id) {
        await actions.updateRequest(data);
      } else {
        await actions.createRequest(data);
      }

      this.setState({
        showReview: false,
        reason: '',
        showAlertMessage: true,
        alertMessage: 'requestUpdate.closeTcModal.successMessage',
      });
      this.props.actions.getRequestUpdate(tcId, testingEventId);
      this.props.actions.getNotViewedNotificationsCount(userId);
      this.props.toggleModal();
    } else {
      this.setState({
        showReview: true,
      });
    }
  }

  onBack() {
    const { showReview } = this.state;
    const { currentRequest } = this.props;

    this.setState({
      showReview: false,
    });
    if (!showReview) {
      this.props.toggleModal(true);
      this.setState({
        reason:
          currentRequest && currentRequest.data && currentRequest.data.eventClose
            ? currentRequest.data.eventClose.reason
            : '',
      });
    }
  }

  onCloseModal() {
    const { currentRequest } = this.props;
    this.setState({
      showReview: false,
      reason:
        currentRequest && currentRequest.data && currentRequest.data.eventClose
          ? currentRequest.data.eventClose.reason
          : '',
    });
    this.props.toggleModal();
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
      alertMessage: '',
    });
  }

  render() {
    const { showAlertMessage, alertMessage, reason, showReview } = this.state;

    const { currentRequest, errorUpdateRequest, modalIsOpen } = this.props;
    const pendingCloseRequest =
      currentRequest.id && currentRequest.type === REQUEST_UPDATE_TYPE.closeTcEvent;
    const savedReason =
      currentRequest && currentRequest.data && currentRequest.data.eventClose
        ? currentRequest.data.eventClose.reason
        : '';

    return (
      <div>
        <ModalInfo
          containerClass="modal-close-request-container"
          className="modal-close-request"
          modalIsOpen={modalIsOpen}
          closeModal={this.onCloseModal}
          onCancel={this.onBack}
          onSubmit={this.onSubmit}
          headerTitle={this.props.t('requestUpdate.title')}
          saveLabel={this.props.t(
            showReview ? 'requestUpdate.review.submitBtn' : 'requestUpdate.reviewBtnLabel'
          )}
          cancelLabel={this.props.t(
            showReview ? 'requestUpdate.review.goBackBtn' : 'common.labels.back'
          )}
          showCancel>
          {showReview ? (
            <>
              <h5 className="mb-3">{this.props.t('requestUpdate.review.title')}</h5>
              <AlertNotice message={this.props.t('requestUpdate.review.infoMessage')} />
              <div className="border-bottom-gray pb-1 mb-2 fw-bold">
                {this.props.t('requestUpdate.closeTCOption')}
              </div>
              <div className="fw-bold mb-1 orange-chelsea-color">
                {this.props.t('requestUpdate.closeTcModal.reasonLabel')}
              </div>
              <div className="orange-chelsea-color">
                {reason ? reason : this.props.t('requestUpdate.closeTcModal.noReasonMessage')}
              </div>
            </>
          ) : (
            <>
              <h4 className="mb-3">
                {this.props.t('requestUpdate.closeTcModal.title')}
                {pendingCloseRequest && (
                  <>
                    {' '}
                    -{' '}
                    <span className="no-wrap">
                      {this.props.t('requestUpdate.rescheduleTCModal.pending')} <PendingIcon />
                    </span>
                  </>
                )}
              </h4>
              <AlertNotice
                message={this.props.t(
                  isEmpty(currentRequest)
                    ? 'requestUpdate.closeTcModal.infoMessage'
                    : 'requestUpdate.closeTcModal.infoPendingMessage'
                )}
              />

              {pendingCloseRequest && (
                <div className="cancel-button">
                  <button className="btn-link" onClick={this.cancelRequest}>
                    <CloseCircle />
                    <span className="ps-1">
                      {this.props.t('requestUpdate.closeTcModal.cancelRequestBtn')}
                    </span>
                  </button>
                </div>
              )}

              <Textarea
                className="mb-1"
                name="reason"
                value={reason}
                label={this.props.t('requestUpdate.closeTcModal.reasonLabel')}
                labelInfo={this.props.t('common.labels.optional')}
                onChange={this.onChange}
                clearValue={() => this.onChange({ target: { value: '' } })}
                isValueChanged={!!reason}
                maxLength={MAX_LENGTH}
              />
            </>
          )}
        </ModalInfo>
        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={errorUpdateRequest ? 'errors.somethingWentWrong' : alertMessage}
          isError={errorUpdateRequest}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentRequest: state.requestUpdate.currentRequest,
    errorUpdateRequest: state.requestUpdate.errorUpdateRequest,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...requestUpdateActions, ...notificationsActions }, dispatch),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CloseTestCenter));

CloseTestCenter.propTypes = {
  t: PropTypes.func.isRequired,
};

CloseTestCenter.defaultProps = {};
